import { render } from "./RecycleBin.vue?vue&type=template&id=15264abb&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"

import "./RecycleBin.vue?vue&type=style&index=0&id=15264abb&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15264abb"]])

export default __exports__